<template>
  <custom-dialog :title="model.title" width="448px" :visible="visible" v-on="$listeners" class="publish-version-dialog" :append-to-body="true">
    <div class="dialog-body">
      <el-form ref="form" :rules="rules" :model="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('dms_publish_version_dialog.TCPban_ben')" prop="version">
              <el-input v-model="form.version" :placeholder="$t('Common.com_please_input')" type="number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('Common.com_cancel') }}
      </el-button>
      <el-button type="primary" @click="onSave">
        {{ $t('Common.com_confirm') }}
      </el-button>
    </div>
    <batch-publish-version v-if="batchPublishVersionVisible" @close="batchPublishVersionVisible = false" :list="model.list" :version="form.version" @success="onSuccess"></batch-publish-version>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis.js';
import dialogMixins from '@/mixins/dialog_mixins';
import batchPublishVersion from './batch_publish_version.vue';

export default {
  mixins: [dialogMixins],
  components: { batchPublishVersion },
  props: {
    protocolId: String,
    tcpVersion: String,
  },
  data() {
    return {
      form: {
        version: '',
      },
      batchPublishVersionVisible: false,
    };
  },
  watch: {
    tcpVersion: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form.version = val;
        }
      },
    },
  },

  computed: {
    rules() {
      return {
        version: [
          { required: true, message: this.$t('Common.com_required') },
          { min: 0, message: this.$t('Common.com_rules_number_min', [0]) },
        ],
      };
    },
  },
  methods: {
    onSuccess() {
      this.$emit('success');
      this.closeDialog();
    },
    closeDialog() {
      this.visible = false;
    },
    onSave() {
      this.$refs.form.validate((val) => {
        if (val) {
          if (!this.model.isBatch) {
            this.$postJSON(`${apis.ProtocolPublishPublish}/${this.protocolId}/${this.form.version}`, {}, true).then(() => {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.$emit('success');
              this.closeDialog();
            });
          } else {
            this.batchPublishVersionVisible = true;
          }
        }
      });
    },
  },
  mounted() {
    this.initRule();
  },
};
</script>

<style lang="scss">
.publish-version-dialog {
  .el-form-item {
    width: 100%;
    text-align: left;
  }
}
</style>
